import { z } from 'zod';

export const ORGANIZED_MATCH_NOTES_MAX = 500;
export const MIN_TURN_DURATION_MINUTES = 30;
export const MAX_ORGANIZED_MATCHES_PER_BATCH = 10;

const scheduleSchema = z.object({
  date: z.string().min(1, 'Elegí la fecha'),
  time: z.string().min(1, 'Elegí la hora'),
  durationMinutes: z
    .number({ invalid_type_error: 'Ingresá la duración' })
    .int('Ingresá la duración en minutos')
    .min(
      MIN_TURN_DURATION_MINUTES,
      `La duración mínima es de ${MIN_TURN_DURATION_MINUTES} minutos`,
    ),
});

/**
 * Form for creating or editing an organized match (Turnos grid). Only edit mode carries a
 * `schedule`; `now` is the club-local "yyyy-MM-ddTHH:mm" and is compared as text, never through
 * Date, because both sides are wall-clock times of the club. The backend rejects a start in the
 * past too: this only saves the round trip.
 */
export const makeOrganizedMatchSchema = (now?: string) =>
  z
    .object({
      sportUid: z.string().min(1, 'Elegí un deporte'),
      playersPerTeam: z.number().int().positive(),
      matchType: z.enum(['FRIENDLY', 'COMPETITIVE']),
      gender: z.string(),
      notes: z
        .string()
        .max(ORGANIZED_MATCH_NOTES_MAX, `Máximo ${ORGANIZED_MATCH_NOTES_MAX} caracteres`),
      players: z.array(z.object({ email: z.string(), name: z.string() })),
      quantity: z.number().int().min(1).max(MAX_ORGANIZED_MATCHES_PER_BATCH),
      schedule: scheduleSchema.optional(),
    })
    .superRefine(({ schedule }, ctx) => {
      if (schedule && now && `${schedule.date}T${schedule.time}` <= now) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['schedule', 'date'],
          message: 'El partido tiene que empezar en el futuro.',
        });
      }
    });

export type OrganizedMatchFormData = z.infer<ReturnType<typeof makeOrganizedMatchSchema>>;
